export default "__VITE_ASSET__D$KMsr6o__"